import { axios } from 'src/boot/axios.js'
import {
  Loading,
  Notify,
  LocalStorage,
  Cookies
} from 'quasar'
import Store from 'src/store/index'
import notifyStore from 'src/store/modules/notify/index'
// import router from 'src/router'

const state = {
  profile: {}
}

const getters = {
  profile (state) {
    return state.profile
  }
}

const mutations = {
  SET_PROFILE: (state, response) => {
    state.profile = response
  }
}

const actions = {
  // ------------
  // LOGIN
  // ------------
  LOGIN (context, payload) {
    Loading.show()

    return new Promise((resolve, reject) => {
      const {
        email,
        password,
        stayLogin
      } = payload

      axios.post(context.rootState.endpoint.login, {
        email, password
      })
        .then((response) => {
          const {
            data: {
              data,
              message
            },
            status
            // statusText
          } = response

          // INVALID
          if (status !== 200) {
            Notify.create({
              html: 'true',
              message,
              color: 'red'
            })
          } else {
            const { token, module, user } = data
            const expires = stayLogin ? 7 : 1
            Cookies.set('jwt', token, {
              expires
            })
            LocalStorage.set('module', module)
            LocalStorage.set('user', user)
            LocalStorage.set('drawer', false)
            LocalStorage.set('dark', false)

            Notify.create({
              html: 'true',
              message,
              color: 'green'
            })

            Loading.hide()

            setTimeout(() => {
              // router.push('/')
              const searchParams = new URLSearchParams(window.location.search)
              const lastPath = searchParams.get('redirect_to')
              LocalStorage.set('force-reload-login', Math.random() * 1000)
              window.location.href = lastPath || '/'
            }, 500)

            resolve(data)
          }
        })
        .catch(() => {
          // notifyStore.actions.FETCH_ERROR(Store(), error)

          Loading.hide()

          reject()
        })
    })
  },
  // ------------
  // FORGOT PASSWORD
  // ------------
  async FORGOT_PASSWORD (context, payload) {
    Loading.show()

    const response = await (function () {
      return {
        data: {
          data: [],
          message: 'Silakan cek Email Anda'
        },
        status: 200
      }
    })()

    const {
      data: {
        data,
        message
      },
      status
      // statusText
    } = response

    Loading.hide()

    if (status !== 200) {
      notifyStore.actions.FETCH_ERROR(Store(), response)
    } else {
      Notify.create({
        html: 'true',
        message,
        color: 'green'
      })

      // router.push('/login')
      this.$router.push('/login')

      return {
        data,
        status,
        message
      }
    }
  },
  // ------------
  // TOKEN CHECK
  // ------------
  async TOKEN_CHECK (context, payload) {
    const response = await (() => {})
    return response
  },
  // ------------
  // LOGOUT
  // ------------
  LOGOUT () {
    LocalStorage.remove('module')
    LocalStorage.remove('user')
    Cookies.remove('jwt')

    this.$router.push('/login')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
